module.exports = __webpack_public_path__ + "static/media/32.78447a48.avif";